/** @jsx jsx */
import { jsx } from 'theme-ui';
import { graphql } from 'gatsby';
import ProductPage from '../components/EventProductPage/EventProductPage';

export default function ProductTemplate({
  data: {
    event,
    product,
    previous,
    next,
    site: { siteMetadata },
  },
  pageContext,
  location,
  navigate,
}) {
  const allProducts = product?.producer?.products || [];
  const otherProducts = allProducts
    .filter(other => other.id !== product.id)
    .slice(0, 6);
  return (
    <ProductPage
      {...pageContext}
      event={event}
      product={product}
      otherProducts={otherProducts}
      otherProductsName={product?.producer?.name}
      previous={previous}
      next={next}
      siteTitle={siteMetadata.title}
      location={location}
      navigate={navigate}
    />
  );
}
export const pageQuery = graphql`
  query ProductTemplate($id: String!, $previousId: String, $nextId: String) {
    product(id: { eq: $id }) {
      id
      ...EventProductPage
      producer {
        name
        products {
          ...EventProductPage_Related
        }
      }
    }
    previous: product(id: { eq: $previousId }) {
      ...ChangeProductLink
    }
    next: product(id: { eq: $nextId }) {
      ...ChangeProductLink
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`;
